import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Fade = props => {
  return <Root {...props} />;
};

Fade.propTypes = {
  delay: PropTypes.number,
  duration: PropTypes.number,
  animate: PropTypes.bool,
};

Fade.defaultProps = {
  delay: 0,
  duration: 0.5,
  animate: true,
};

const Root = styled.div`
  opacity: ${props => (props.animate ? 1 : 0)};
  transition: transform ${props => props.duration}s,
    opacity ${props => props.duration}s;
  transition-delay: ${props => (props.animate ? props.delay : 0)}s;
`;

export default Fade;
